import { render, staticRenderFns } from "./SchoolReport.vue?vue&type=template&id=3615fd60"
import script from "./SchoolReport.vue?vue&type=script&lang=js"
export * from "./SchoolReport.vue?vue&type=script&lang=js"
import style0 from "./SchoolReport.vue?vue&type=style&index=0&id=3615fd60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports